export default {
  language: '한국어',
  nav: {
    home: "홈페이지",
    dealer: "리셀러",
    help: "도움&피드백",
    subscription: "구독",
    couponCenter: "쿠폰 홀"
  },
  userMenu: {
    login: "등록해요",
    profile: "개인 정보",
    subscription: "구독",
    promotion: "나의 홍보",
    help: "도움&피드백",
    order: "주문 기록",
    wallet: "내 지갑",
    coupons: "내 쿠폰",
    changeLang: "언어 전환",
    logout: "퇴출"
  },
  footer: {
    aboutUsTitle: "회사 소개",
    aboutUs: "회사 소개",
    contactUs: "문의하기",
    business: "비즈니스 제휴",
    legalTitle: "법률",
    terms: "이용 약관",
    privacy: "개인정보 처리방침",
    refund: "환불 정책",
    regionTitle: "국가/지역",
    regionChina: "중국",
    language: "언어",
    langZhCN: "중국어(간체)",
    langEn: "영어",
    serviceTitle: "고객 서비스",
    helpSupport: "도움 & 지원",
    onlineService: "온라인 고객센터"
  },
  header: {
    helpTitle: "무엇을 도와드릴까요?",
    searchPlaceholder: "검색할 키워드를 입력하세요",
    recommendTitle: "추천",
    changeAnother: "다시 보기",
    subscriptionTitle: "구독 서비스",
    userCenterTitle: "개인 정보",
    myAccountTitle: "내 계정",
    myPromotionTitle: "나의 홍보",
    myWalletTitle: "내 지갑",
    myCouponsTitle: "내 쿠폰",
    orderTitle: "주문 내역",
    couponCenterTitle: "쿠폰 홀",
    registerCouponTitle: "신규 회원 쿠폰",
    '立即與OTTBUS合作吧！':'당장 OTTBUS와 협력하십시오!',
    '加入我們，開啓賺錢的旅程！':'저희와 함께 돈을 벌기 위한 여행을 시작하세요!',
    '馬上開始':'벌이를 시작해라',
  },
  login: {
    welcomeTitle: "안녕하세요!",
    welcomeSubtitle: "멋진 경험을 즐기세요!",
    cardTitle: "로그인 또는 회원가입",
    emailPlaceholder: "이메일",
    passwordPlaceholder: "비밀번호",
    useCodeLogin: "인증코드로 로그인",
    codePlaceholder: "인증코드",
    sending: "전송중...",
    sendCode: "코드 전송",
    sent: "전송됨",
    passwordLogin: "비밀번호 로그인",
    instruction: "OTTBUS에 가입할 때 사용한 이메일로 로그인하세요",
    continue: "계속",
    or: "또는",
    termsPrefix: "계속하면 다음에 동의하게 됩니다: ",
    termsLinkText: "이용 약관",
    privacyPrefix: " 그리고 다음을 읽었음을 확인합니다: ",
    privacyLinkText: "개인정보 처리방침",
    discountRate: "할인 율최대80%",
    discountDesc: "구독 부담 절반으로, 즐거움 배로!"
  },
  auth: {
    confirmLogout: "시스템에서 로그아웃하시겠습니까?",
    confirmTitle: "알림",
    ok: "확인",
    cancel: "취소",
    invalidEmail: "올바른 이메일 주소를 입력하세요",
    passwordRequired: "비밀번호는 비워둘 수 없습니다",
    loginSuccess: "로그인 성공",
    codeRequired: "인증코드를 입력하세요",
    passwordLength: "비밀번호 길이는 6~20자여야 합니다",
    passwordMismatch: "두 비밀번호가 일치하지 않습니다",
    registerLoginSuccess: "등록 및 로그인 성공",
    unsupportedPasswordLogin: "이 계정은 비밀번호 로그인을 지원하지 않습니다. 코드 로그인을 사용하세요.",
    loginFailedUseCode: "로그인 실패, 코드 로그인을 사용하세요",
    loginFailedRetry: "로그인 실패, 다시 시도해 주세요",
    codeSendFailed: "인증코드 전송 실패, 잠시 후 다시 시도하세요"
  },
  setPassword: {
    title: "비밀번호 설정",
    description: "계정 보안을 강화하고 인증코드를 받지 못해 로그인할 수 없는 상황을 방지하기 위해 로그인 비밀번호를 설정하세요.",
    passwordPlaceholder: "비밀번호 입력",
    confirmPasswordPlaceholder: "비밀번호 확인",
    requirementsTitle: "비밀번호에는 다음이 포함되어야 합니다:",
    requirementLength: "8~20자",
    requirementFormat: "영문자와 숫자",
    requirementMatch: "두 비밀번호가 일치함",
    continue: "계속",
    skip: "건너뛰기",
    success: "비밀번호가 성공적으로 설정되었습니다",
    failure: "비밀번호 설정에 실패했습니다. 다시 시도해 주세요"
  },
  helpPage: {
    feedbackCardTitle: "피드백 구매하기",
    feedbackCardSubtitle: "문제를 알려주세요",
    serviceCardTitle: "온라인 고객센터",
    serviceCardSubtitle: "24시간 원스톱 서비스",
    dialogTitle: "문제 피드백",
    formProblemTitle: "피드백 내용",
    formProblemPlaceholder: "피드백할 문제를 설명해 주세요",
    formContactTitle: "연락처",
    formContactPlaceholder: "연락처를 입력해 주세요",
    submit: "구매하기",
    problemRequired: "문제 설명은 비워둘 수 없습니다",
    contactRequired: "연락처는 비워둘 수 없습니다",
    confirmSubmit: "피드백을 구매하기하시겠습니까?",
    confirmTitle: "알림",
    ok: "확인",
    cancel: "취소",
    submitSuccess: "구매하기 완료!",
    '聯繫專屬客服以獲取高效支持': '효율적인 지원을 받기 위해 전용 고객 서비스에 연락하세요.',
    // 도움말 센터 다국어
    helpCenter: "도움말 센터",
    searchPlaceholder: "도움말 센터 검색...",
    hotArticles: "인기 질문",
    frequentlyReadArticles: "자주 읽는 문서",
    browseAllCategories: "모든 카테고리 보기",
    categories: "카테고리",
    searchResults: "검색 결과",
    clearSearch: "검색 지우기",
    noResults: "결과를 찾을 수 없습니다",
    noArticles: "아직 문서가 없습니다",
    loading: "로딩 중...",
    loadMore: "더 보기",
    back: "뒤로",
    goToWebsite: "웹사이트로 이동",
    howCanWeHelp: "무엇을 도와드릴까요?",
    articlesOn: "문서 분류",
    viewCount: "조회수",
    defaultCategoryDesc: "관련 도움말 문서 보기"
  },
  helpDetail: {
    title: "도움말 센터",
    updated: " 업데이트",
    relatedArticles: "관련 문서"
  },
  userProfile: {
    title: "개인 정보",
    nickname: "닉네임",
    email: "이메일",
    password: "비밀번호",
    editNickname: "닉네임 수정",
    nicknamePlaceholder: "닉네임을 입력하세요",
    submit: "제출",
    editPassword: "비밀번호 수정",
    codeSent: "인증코드가 {email}(으)로 전송되었습니다. 확인해 주세요:",
    codePlaceholder: "인증코드 입력",
    sendCode: "코드 전송",
    resendIn: "{time}S 후 재전송",
    newPasswordPlaceholder: "비밀번호를 설정하세요",
    confirmPasswordPlaceholder: "비밀번호 확인",
    editEmail: "이메일 수정",
    newEmailPlaceholder: "새 이메일을 입력하세요",
    updateSuccess: "수정 성공",
    passwordRequired: "비밀번호는 비워둘 수 없습니다",
    passwordMismatch: "두 비밀번호가 일치하지 않습니다",
    nicknameRequired: "닉네임을 입력하세요!",
    uploadFailed: "파일 업로드 실패, 다시 시도해 주세요",
    uploading: "이미지 업로드 중, 잠시만 기다려 주세요..."
  },
  subscriptionPage: {
    title: "구독 서비스",
    tagRecharging: "충전 중",
    tagToRedeem: "교환 대기",
    tagSubscribed: "구독 중",
    productLabel: "제품:",
    codeLabel: "교환 코드:",
    startTime: "시작 시간:",
    endTime: "종료 시간:",
    remark: "비고:",
    renewService: "서비스 갱신",
    goRedeem: "교환하러 가기",
    newTicket: "티켓 생성",
    faq: "자주 묻는 질문",
    emptyText: "아직 구독 내용이 없습니다",
    goSubscribe: "구독하러 가기",
    dialogNewTicketTitle: "티켓 생성",
    emailLabel: "이메일",
    emailPlaceholder: "이메일을 입력하세요",
    questionTypeLabel: "문제 유형",
    selectPlaceholder: "선택하세요",
    questionDetailLabel: "문제 상세",
    submit: "제출",
    redeemSuccessTitle: "교환 성공",
    accountLabel: "계정:",
    passwordLabel: "비밀번호:",
    rechargeAccount: "충전 계정:",
    copySuccess: "교환 코드가 복사되었습니다!",
    copyFail: "복사 실패",
    confirmRedeem: "정말 교환하시겠습니까?",
    emailRequired: "이메일을 입력하세요!",
    questionTypeRequired: "문제 유형을 선택하세요!",
    detailRequired: "문제 상세를 입력하세요!",
    submitSuccess: "제출 완료!",
    '订单编号': '주문번호',
    '联系客服': '고객센터연락',
    expand: '펼치기',
    collapse: '접기',
    adminRemark: '비고',
    captchaLabel: '인증코드',
    fetching: '가져오는 중...',
    clickToGet: '인증코드 받기',
    viewDetail: '인증코드 상세 보기',
    noCaptchaEmail: '인증코드를 가져올 수 없습니다. 다시 보내거나 1분 후에 다시 시도해 주세요'
  },
  orderPage: {
    title: "주문 기록",
    all: "전체",
    unpaid: "미결제",
    paid: "결제 완료",
    completed: "완료",
    refunded: "환불 완료",
    thName: "주문 이름",
    thDuration: "구독 기간",
    thAmount: "결제 금액",
    thStart: "발효 시간",
    thStatus: "주문 상태",
    idPrefix: "ID:",
    emptyText: "내용이 없습니다",
    status: {
      0: "미결제",
      1: "결제 완료",
      2: "완료",
      9: "환불 완료",
      "-1": "취소됨"
    },
    duration: {
      1: "1개월",
      3: "3개월",
      6: "6개월",
      12: "12개월"
    },
    '订单编号': '주문번호',
    '操作': '조작',
    '退款': '환불',
    '去支付': '결제하기',
    cancelOrder: '주문 취소',
    cancelOrderConfirm: '이 주문을 취소하시겠습니까?',
    cancelOrderSuccess: '주문이 취소되었습니다',
    cancelOrderFailed: '취소에 실패했습니다. 잠시 후 다시 시도해 주세요',
    cancelOrderForbiddenPaid: '이 주문은 이미 결제 성공 기록이 있어 취소할 수 없습니다',
    '退款申请': '환불신청',
    '退款理由': '환불이유',
    '请填写退款理由': '환불이유를기입해주십시오.',
    '订单不存在': '주문이 없습니다',
    '订单不支持退款': '주문은 환불을 지원하지 않습니다',
    '申请失败': '신청 실패',
    '操作成功': '작업 성공',
    refundStatus: {
      1: '환불신청중',
      2: '확인 대기중',
      3: '관리자 거부',
      4: '환불완료',
      5: '고객 거부'
    },
    // 환불 확인 관련
    confirmRefund: '환불 확인',
    refundConfirmTitle: '환불 확인',
    refundAmountLabel: '환불 금액',
    refundConfirmTip: '환불을 확인하면 금액이 지갑으로 반환됩니다',
    agreeRefund: '환불 동의',
    rejectRefund: '환불 거부',
    refundSuccess: '환불 성공, 금액이 지갑으로 반환되었습니다',
    refundRejected: '환불이 거부되었습니다',
    operationFailed: '작업 실패',
    refundDisabledTip: '환불 기능이 활성화되지 않았습니다. 고객 서비스에 문의하세요',
    checkRefundFailed: '환불 권한 확인 실패',
    refundContactService: '환불은 고객 서비스에 문의하세요',
    adminRemark: '비고',
    refundApplySuccess: '환불 신청이 제출되었습니다',
    refundRemarkLabel: '심사 결과'
  }
  ,
  indexPage: {
    titlePart1: "",
    titlePart2: "제공하는것",
    menuRecommend: "전부",
    sharingUsersSuffix: " 명의 사용자가 이용 중",
    buyNow: "구매하러 가기",
    more: "상세보기",
    foldUp: " 숨기기 ",
    noContent: "내용이 없습니다",
    advantagesTitlePart1: "",
    advantagesTitlePart2: "OTTBUS 의 장점",
    consultNow: "상담하기",
    feedbackTitle: "사용자 피드백",
    bulletCheap: "합리적인 가격, 패밀리 플랜이 더 경제적",
    bulletDesktopOnly: "데스크톱 전용: Windows 및 macOS",
    coupon: {
      headerTitle: "신규 사용자 전용 혜택",
      headerSubtitle: "환영합니다, 당신에게 드리는 선물입니다",
      discountConditionPrefix: "",
      discountConditionSuffix: " 사용 가능",
      directDiscount: "최소 금액 없이 바로 할인",
      validityLabel: "유효기간",
      cardNote: "첫 주문 시 사용 가능",
      rule1: "신규 사용자 즉시 수령 가능",
      rule2: "전 플랫폼 사용 가능, 일부 상품 제외",
      rule3: "수령 후 12개월 이내 유효",
      receiveBtn: "지금 받기",
      successTitle: "수령 완료!",
      successMessage: "쿠폰이 계정에 지급되었습니다. 지금 사용해 보세요!",
      successOk: "확인"
    },
    dialog: {
      buyTitle: "제품 구매",
      type: "유형",
      direct: "직충",
      shared: "공유",
      duration: "기간",
      couponCode: "할인코드",
      couponPlaceholder: "내용을 입력하세요",
      note: "안내: 디지털 상품의 특성상 구매 24시간 이후에는 환불이 불가합니다. 서비스 이용 중 문제가 발생할 경우 빠르게 조치하여 이용 기간을 보상해 드리며, 쾌적한 사용 경험을 보장합니다.",
      submit: "제출",
      accountTitle: "계정 정보",
      accountLabel: "계정 정보",
      passwordLabel: "비밀번호",
      backupCodeLabel: "복구코드 설정하는 법",
      payTitle: "결제 수단 선택",
      payMethod: "OTTBUS은 귀하의 카드 정보를 저장하지 않으며, 모든 거래는 외부 결제 제공업체에 의해 보호, 처리 및 승인됩니다. (결제 이동에 실패할 경우 기기를 변경하여 다시 시도해 주세요.)",
      confirm: "확인",
      save: "절약",
      orgPrice: "정가：",
      '请填写充值账号': '충전할 계정 번호를 입력해 주세요.',
      '请填写充值账号密码': '계정의 비밀번호를 입력해 주세요.',
      '请填写充值账号备用码': '충전 계정의 복구코드를 최소 3개 입력해 주세요',
      '节约': '절약',
      '注意事项': '주의사항',
      googleBakCode: '설정 방법Google 대체 인증 코드',
      noStock: '일시 품절',
      '备注': '안내',
      '请填写充值账号备注': '유튜버 이름과 해당 멤버십 등급을 입력해 주세요.',
      '数量': '수량',
      '请输入您要充值的账户(GoogleMail)': '충전할 계정 번호를 입력해 주세요.(Google Mail)',
      '购买须知': '구매 전 필수 확인 사항'
    },
    validate: {
      fillAccount: "충전할 계정 번호를 입력해 주세요.",
      fillPassword: "계정의 비밀번호를 입력해 주세요.",
      choosePayMethod: "결제 수단을 선택하세요"
    },
    adv: {
      payNowTitle: "실시간 제공",
      payNowDesc: "결제 후 즉시 이용 가능 – 기다림 없이 바로 시작",
      customerServiceTitle: "고객 지원",
      customerServiceDesc: "OTTBUS 가 24시간 온라인 상담 서비스를 제공합니다",
      globalPayTitle: "글로벌 결제",
      globalPayDesc: "100개국 이상에서 안전한 결제 가능",
      shareTitle: "구독 공유",
      shareDesc: "비용 효율적인 고급 구독 공유 –지역별 우선 지원",
      refundTitle: "빠른 환불",
      refundDesc: "24시간 환불정책을 충족하면 무조건 환불해드립니다",
      premiumTitle: "고급 서비스 센터",
      premiumDesc: "OTTBUS 의 ‘원스톱’ 고급 구독",
    },
    type: {
      '视频': '비디오',
      '音乐': '음악',
      'AI': 'AI',
      '办公': '사무',
      '学习': '학습',
      '其他': '기타'
    },
    month: " 월",
    months: " 개월",
    permanent: "평생",
    pay: {
      creditcardKR: "South Korea Credit Card",
      ebankingKR: "South Korea Internet Banking",
      kakaopay: "KakaoPay",
      payco: "PAYCO",
      ssgpay: "SSG Pay",
      samsungpay: "Samsung Pay",
      alipayHK: "중국 본토 알리페이",
      alipayWalletHK: "홍콩 알리페이",
      alipayTW: "중국 본토 알리페이",
      jkoTW: "JKOPay",
      useWallet: "지갑 잔액 사용",
      walletBalance: "지갑 잔액",
      walletDeduct: "지갑 차감",
      walletDeductInput: "지갑 차감 금액",
      walletDeductMaxTip: "최대 차감 가능",
      remainingToPay: "추가 결제 필요",
      enterPayPassword: "6자리 결제 비밀번호 입력",
      noPasswordTip: "결제 비밀번호가 설정되지 않았습니다",
      goSetPassword: "설정하기",
      paySuccess: "결제 성공",
      payFailed: "결제 실패, 다시 시도해 주세요",
      paymentUrlError: "결제 링크를 가져오지 못했습니다. 다시 시도해 주세요",
      insufficientBalance: "지갑 잔액이 부족합니다",
      walletAlreadyPaid: "지갑으로 결제 완료",
      walletAlreadyUsed: "이 주문은 이미 지갑으로 결제되었습니다",
      walletPendingTip: "지갑 차감이 예약되었습니다. 결제 성공 후 실제 차감됩니다",
      regionAutoDetectFallback: "현재 지역을 확인할 수 없어 한국, 홍콩, 대만 결제 수단을 모두 표시했습니다. 직접 선택해 주세요.",
      antomCashierTitle: "결제 페이지로 이동 중입니다",
      antomCashierDescription: "이 페이지에서 선택한 결제 컴포넌트를 직접 렌더링합니다. 정상적으로 보이지 않으면 아래 버튼으로 다시 시도해 주세요.",
      antomCashierLoading: "결제 컴포넌트를 불러오는 중입니다...",
      antomCashierReady: "결제 컴포넌트가 준비되었습니다. 아래에서 결제를 완료해 주세요.",
      antomCashierOpenFailed: "결제 페이지를 열지 못했습니다. 다시 시도해 주세요.",
      antomCashierMissingSession: "결제 세션이 만료되었습니다. 상품 페이지로 돌아가 다시 주문해 주세요.",
      antomCashierRetry: "결제 다시 열기",
      antomCashierBackHome: "홈으로 돌아가기",
      antomCashierOrderCode: "주문번호",
      antomCashierAmount: "결제 금액",
      antomCashierSuccessHint: "결제가 제출되었습니다. 주문 상태 업데이트를 기다려 주세요.",
      antomCashierCancelHint: "결제가 취소되었습니다. 다시 시도할 수 있습니다.",
      antomCashierEventPrefix: "결제 컴포넌트 상태",
      antomResultTitle: "결제 결과 확인 중입니다",
      antomResultDescription: "결제가 끝난 뒤 이 페이지에서 최신 주문 상태를 조회합니다.",
      antomResultLoading: "최신 주문 상태를 조회하는 중입니다...",
      antomResultPending: "결제 결과를 동기화하는 중입니다. 잠시만 기다려 주세요.",
      antomResultPaid: "주문이 결제되었습니다.",
      antomResultCompleted: "주문이 완료되었습니다.",
      antomResultRefunded: "주문이 환불되었습니다.",
      antomResultUnknown: "최종 상태를 아직 확인하지 못했습니다. 잠시 후 주문센터에서 다시 확인해 주세요.",
      antomResultMissingOrder: "결제 주문번호가 없어 결과를 조회할 수 없습니다.",
      antomResultNoLogin: "로그인되어 있지 않아 주문 상태를 자동으로 조회할 수 없습니다. 로그인 후 주문센터에서 확인해 주세요.",
      antomResultQueryFailed: "주문 상태 조회에 실패했습니다. 잠시 후 다시 시도해 주세요.",
      antomResultOrderStatus: "주문 상태",
      antomResultRetry: "다시 조회",
      antomResultViewOrders: "주문 보기"
    }
  }
  ,
  promotionPage: {
    myPromotion: "나의 홍보",
    myWallet: "나의 지갑",
    code: "홍보링크：",
    promotionRecords: "홍보 기록",
    totalCommission: "총 커미션: ",
    thOrderName: "주문 이름",
    thDuration: "구독 기간",
    thPaid: "결제 금액",
    thEffective: "발효 시간",
    thBuyer: "구매자",
    thCommission: "커미션",
    thStatus: "상태",
    settled: "정산 완료",
    pending: "정산 대기",
    unpaid: "결제 대기",
    refunded: "환불 완료",
    goodsDetail: "홍보 상품",
    thPrice: "가격",
    commissionRate: "커미션 비율",
    commissionAmount: "커미션 금액",
    remark: "비고",
    withdrawable: "출금 가능:",
    withdraw: "출금",
    withdrawalRecords: "출금 기록",
    totalWithdrawal: "총 출금: ",
    thWithdrawAmount: "출금 금액",
    thBank: "입금 은행카드",
    thCardholder: "카드 소유자",
    thWithdrawTime: "출금 시간",
    thWithdrawStatus: "출금 상태",
    withdrawAmount: "출금 금액",
    bankCard: "입금 은행카드 번호",
    cardholder: "카드 소유자 이름",
    placeholderWithdrawAmount: "출금 금액을 입력하세요",
    placeholderBankCard: "은행카드 번호를 입력하세요",
    placeholderCardholder: "카드 소유자 이름을 입력하세요",
    '链接复制成功': '링크 복사 성공',
    adAgentNoWithdraw: "광고 대리인은 출금할 수 없습니다",
    adAgentNotice: "광고 대리인 사용자이므로 출금이 불가능하며 커미션도 지급되지 않습니다. 문의 사항이 있으시면 고객센터로 연락해 주세요.",
    // 은행카드 관리
    myBankCards: "내 은행카드",
    addBankCard: "은행카드 추가",
    editBankCard: "은행카드 수정",
    noBankCards: "은행카드가 없습니다. 먼저 추가해 주세요",
    selectBankCard: "은행카드 선택",
    manualInput: "직접 입력",
    bankName: "은행 이름",
    cardNumber: "카드 번호",
    cardHolder: "카드 소유자",
    placeholderBankName: "은행 이름을 입력하세요",
    placeholderCardNumber: "카드 번호를 입력하세요",
    placeholderCardHolder: "카드 소유자 이름을 입력하세요",
    setAsDefault: "기본 카드로 설정",
    defaultCard: "기본",
    save: "저장",
    saveSuccess: "저장 완료",
    saveFailed: "저장 실패",
    deleteSuccess: "삭제 완료",
    confirmDeleteCard: "이 은행카드를 삭제하시겠습니까?",
    confirmWithdraw: "출금하시겠습니까?",
    withdrawSuccess: "출금 신청이 제출되었습니다",
    withdrawAmountExceeded: "출금 금액이 출금 가능 금액을 초과할 수 없습니다",
    // 출금 방법
    myWithdrawAccounts: "내 출금 계좌",
    addWithdrawAccount: "출금 방법 추가",
    editWithdrawAccount: "출금 방법 수정",
    noWithdrawAccounts: "출금 계좌가 없습니다. 먼저 추가해 주세요",
    withdrawType: "출금 방법",
    selectWithdrawType: "출금 방법을 선택하세요",
    usdtAddress: "USDT 지갑 주소 (TRC20)",
    placeholderUsdtAddress: "USDT 지갑 주소를 입력하세요"
  }
  ,
  hello: {
    guideLine1: "이 프로젝트를 구성/사용자 정의하는 방법에 대한 가이드와 레시피는",
    guideCheckOut: "다음을 참조하세요",
    vueCliDocs: "vue-cli 문서",
    installedTitle: "설치된 CLI 플러그인",
    plugins: { babel: "babel", eslint: "eslint" },
    essentialTitle: "필수 링크",
    links: {
      coreDocs: "핵심 문서",
      forum: "포럼",
      communityChat: "커뮤니티 채팅",
      twitter: "Twitter",
      news: "뉴스"
    },
    ecosystemTitle: "에코시스템",
    ecosystem: {
      router: "vue-router",
      vuex: "vuex",
      devtools: "vue-devtools",
      loader: "vue-loader",
      awesome: "awesome-vue"
    }
  }
  ,
  dealerPage: {
    adv1Title: "전문 팀",
    adv1Desc: "전문 팀 서비스, OTTBUS에 합류",
    adv2Title: "공유로 수익",
    adv2Desc: "링크 공유, 구매 시 커미션 획득",
    adv3Title: "갱신 커미션",
    adv3Desc: "사용자 갱신 시 추가 커미션",
    adv4Title: "24시간 서비스",
    adv4Desc: "1:1 전문 연결 서비스",
    advantagesTitle: "우리를 선택할 장점은?",
    advantagesSubtitle: "쉽게 커미션을 얻으세요",
    startNow: "지금 시작",
    howToJoinTitle: "어떻게 합류하나요?",
    howToJoinSubtitle: "쉽게 커미션을 얻으세요",
    join1Title: "계정 등록",
    join1Desc: "먼저 계정을 등록하고, 등록 후 딜러 섹션으로 이동",
    join2Title: "가맹 신청",
    join2Desc: "딜러 섹션에서 신청 후 승인되면 초대 가능",
    join3Title: "초대 공유",
    join3Desc: "초대 링크 공유, 링크 구매 시 커미션 획득",
    shareSlogan: "함께 하세요, 링크 공유로 수익을 시작하세요!",
    startEarning: "지금 바로 수익 시작",
    dialogTitle: "우리와 함께",
    detailSubtitle: "OTTBUS에 합류하시는 것을 환영합니다. 가입을 쉽게 하기 위해 양식을 작성해 주세요.",
    formRealName: "실명",
    placeholderRealName: "이름을 입력하세요",
    formPhone: "전화번호",
    placeholderPhone: "전화번호를 입력하세요",
    formCurrency: "계정 통화",
    formPromotionWhere: "어디에서 OTTBUS를 홍보할 계획인가요?",
    placeholderLink: "링크를 입력하세요",
    formLanguageQuestion: "어떤 언어로 SNS 홍보를 하시나요?",
    selectPlaceholder: "선택하세요",
    formContactHow: "어떻게 연락드리면 될까요?",
    placeholderContactInfo: "연락처를 입력하세요",
    formPaymentWay: "어떤 결제 방식을 사용하시겠습니까?",
    formInviteCode: "초대자가 있다면 초대 코드를 입력",
    placeholderInviteCode: "초대 코드를 입력하세요",
    close: "닫기",
    submit: "구매하기",
    validate: {
      fillRealName: "실명을 입력하세요",
      fillPhone: "전화번호를 입력하세요",
      chooseCurrency: "계정 통화를 선택하세요",
      choosePromotionChannels: "홍보 경로를 선택하세요",
      promotionLinkRequired: "홍보 경로 링크는 비워둘 수 없습니다",
      chooseLanguage: "SNS 언어를 선택하세요",
      chooseContactType: "연락 방법을 선택하세요",
      fillContactInfo: "연락처를 입력하세요",
      choosePaymentWay: "결제 방식을 선택하세요"
    },
    confirmSubmit: "제출하시겠습니까?",
    submitSuccess: "제출 완료!",
    '开启您的推广之旅': '프로모션 시작'
  },
  text: {
    '已经领取过': '이미 수령하였습니다',
    '商品库存不足': '재고 부족',
    '优惠码无效': '잘못된 쿠폰 코드',
    '请填写备注': '메모를 작성하십시오.',
    couponNotFound: '프로모션 코드를 찾을 수 없거나 만료되었습니다',
    couponUsed: '이 프로모션 코드는 이미 사용되었습니다',
    couponExpired: '이 프로모션 코드는 만료되었습니다',
    stockInsufficient: '최대 구매 수량에 도달했습니다'
  },
  wallet: {
    myWallet: "내 지갑",
    balance: "지갑 잔액",
    balanceTip: "플랫폼 내에서만 사용 가능, 출금 불가",
    setPassword: "결제 비밀번호 설정",
    changePassword: "비밀번호 변경",
    records: "거래 내역",
    all: "전체",
    income: "수입",
    expense: "지출",
    refundIncome: "환불 입금",
    paymentExpense: "결제 지출",
    noRecords: "거래 내역이 없습니다",
    loading: "로딩 중...",
    loadMore: "더 보기",
    oldPassword: "현재 비밀번호",
    newPassword: "새 비밀번호",
    password: "결제 비밀번호",
    confirmPassword: "비밀번호 확인",
    enterOldPassword: "현재 비밀번호 입력",
    enterPassword: "6자리 숫자 비밀번호 입력",
    enterConfirmPassword: "비밀번호 재입력",
    passwordTip: "결제 비밀번호는 6자리 숫자입니다",
    confirm: "확인",
    passwordLengthError: "비밀번호는 6자리 숫자여야 합니다",
    passwordFormatError: "비밀번호는 6자리 숫자여야 합니다",
    passwordNotMatch: "비밀번호가 일치하지 않습니다",
    setSuccess: "설정 완료",
    operationFailed: "작업 실패, 다시 시도해 주세요"
  },
  couponHall: {
    pageTitle: "지금 받을 수 있는 쿠폰",
    pageSubtitle: "활동 쿠폰을 한곳에서 확인하고, 수량과 유효기간을 본 뒤 로그인 후 바로 받을 수 있습니다.",
    loginTip: "비회원도 먼저 둘러볼 수 있습니다. 로그인 후 사용 가능한 쿠폰을 계정으로 받아가세요.",
    allGoods: "전체 상품",
    receiveNow: "지금 받기",
    loginToReceive: "로그인 후 받기",
    viewMyCoupons: "내 쿠폰 보기",
    receiveSuccess: "쿠폰을 받았습니다",
    receiveFailed: "쿠폰 받기에 실패했습니다",
    statusAvailable: "받기 가능",
    statusUpcoming: "오픈 예정",
    statusEnded: "종료됨",
    statusSoldOut: "소진됨",
    statusLimitReached: "개인 한도 도달",
    conditionLabel: "사용 조건",
    validityLabel: "유효기간",
    windowLabel: "수령 기간",
    quotaLabel: "수량",
    goodsLabel: "적용 상품",
    unlimited: "무제한",
    remaining: "남은 수량",
    perUserLimit: "1인 한도",
    emptyTitle: "현재 받을 수 있는 쿠폰이 없습니다",
    emptySubtitle: "활동이 아직 없거나 모두 숨김 처리되었습니다. 잠시 후 다시 확인하거나 쇼핑을 계속해 주세요.",
    goShopping: "쇼핑하러 가기"
  },
  coupon: {
    myCoupons: "내 쿠폰",
    couponTip: "쿠폰을 확인하고 관리하세요",
    claimEntrance: "신규 쿠폰 받기",
    claimPageTitle: "신규 사용자 쿠폰",
    claimPageSubtitle: "수령 후 결제 시 바로 사용할 수 있습니다",
    claimNow: "지금 받기",
    loginToClaim: "로그인 후 받기",
    loginRequiredTip: "비회원은 쿠폰 정보를 확인할 수만 있습니다. 로그인 후 계정으로 수령하세요.",
    notClaimedYet: "아직 수령하지 않았습니다",
    alreadyClaimed: "수령 완료",
    previewMode: "미리보기 전용",
    claimSuccess: "수령 성공",
    claimFailed: "수령 실패, 잠시 후 다시 시도해 주세요",
    viewMyCoupons: "내 쿠폰 보기",
    all: "전체",
    unused: "미사용",
    used: "사용됨",
    expired: "만료됨",
    conditionLabel: "사용 조건",
    statusLabel: "상태",
    couponCodeLabel: "쿠폰 코드",
    minSpend: "최소 주문",
    noThreshold: "최소 주문 금액 없음",
    validForDays: "수령 후 {days}일 동안 유효",
    directDiscount: "직접 할인",
    validUntil: "유효기간",
    available: "사용 가능",
    canUse: "사용 가능",
    noCoupons: "쿠폰이 없습니다",
    noCouponsTip: "아직 쿠폰이 없습니다. 쇼핑하고 더 많은 혜택을 받으세요",
    goShopping: "쇼핑하러 가기"
  },
  promotion: {
    invitedUsers: "초대한 사용자",
    userCount: "초대한 사용자 수",
    totalOrders: "총 주문 수",
    pendingCommission: "대기 중인 커미션",
    settledCommission: "정산된 커미션",
    viewOrders: "주문 보기",
    hideOrders: "주문 숨기기",
    noUsers: "초대한 사용자가 없습니다",
    registerTime: "가입일",
    orderStatus: "주문 상태",
    statusPending: "결제 대기",
    statusPaid: "결제 완료",
    statusCompleted: "완료",
    statusRefunded: "환불됨",
    statusUnknown: "알 수 없음"
  },
  orderDetail: {
    relatedProducts: "관련 상품",
    faq: "자주 묻는 질문",
    viewMoreFaq: "더 많은 질문 보기"
  },
  detailPage: {
    selectSku: "SKU 선택",
    sold: "판매량",
    subtotal: "소계",
    couponDiscount: "프로모션 코드 & 쿠폰",
    selectCoupon: "쿠폰을 선택하세요",
    total: "합계",
    hasCoupon: "프로모션 코드가 있으신가요?",
    hasCouponAvailable: "사용 가능한 쿠폰이 있습니다",
    noCoupon: "쿠폰 사용 안함",
    buyNow: "지금 구매",
    outOfStock: "재고 부족",
    howToUse: "사용 방법",
    viewUsageGuide: "사용 가이드 보기",
    noUsageGuide: "사용 가이드가 없습니다",
    faq: "자주 묻는 질문",
    relatedProducts: "관련 상품",
    invalidCoupon: "유효하지 않은 쿠폰",
    invalidCouponConfirmTitle: "쿠폰 무효",
    invalidCouponConfirmMessage: "입력하신 쿠폰이 유효하지 않습니다. 구매를 계속하시겠습니까?",
    continuePurchase: "구매 계속",
    selectDiscount: "할인 선택",
    pleaseSelect: "선택하세요",
    promoCodePlaceholder: "프로모션 코드 입력",
    apply: "적용",
    quantity: "수량",
    unavailableTitle: "상품을 이용할 수 없습니다",
    unavailableMessage: "현재 이 상품은 고객님 지역에서 조회하거나 구매할 수 없습니다. 홈으로 돌아가 다른 상품을 선택해 주세요.",
    unavailableNoSpec: "현재 판매 가능한 옵션이 없습니다. 잠시 후 다시 시도해 주세요.",
    backHome: "홈으로 돌아가기"
  }
}
